import React, { useEffect, useRef } from "react";
import "font-awesome/css/font-awesome.css";
import Icons from "./Common/IconsGroup";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
// import oemSolution from "./images/oem_solution.png";
// import energyDashboard from "./images/energy_dashboard.png";

import "./Styles.css";
import "./Solutions.css";
//import Icons from "./Common/IconsGroup";
import { useLocation } from "react-router-dom";

// const BANNER_CONTENTS = {
//   oem: {
//     label: "OEMs",
//     // img: oemSolution,
//     title: "Powering Smart, Connected Compressor Lines",
//     subTitle:
//       "Transform your compressors into intelligent, connected systems with our ready-to-integrate IoT platform.",
//     contents: [
//       {
//         title: "Ready-to-integrate IoT gateway & APIs",
//         subTitle: "Seamless integration with your existing controller systems.",
//       },
//       {
//         title: "Feedback loop from field data to R&D",
//         subTitle: "Improve product design with real-world performance data.",
//       },
//       {
//         title: "Predictive diagnostics for warranty & quality",
//         subTitle: "Reduce warranty claims and improve customer satisfaction.",
//       },
//       {
//         title: "Partner dashboards for remote management",
//         subTitle: "Enable your customers with powerful monitoring tools.",
//       },
//     ],
//   },
//   serviceProvider: {
//     label: "Service Companies",
//     // img: oemSolution,
//     title: "Next-Gen Compressor Fleet Management",
//     subTitle:
//       "Transform your service operations with intelligent monitoring and automated workflows.",
//     contents: [
//       {
//         title: "Monitor all field compressors centrally",
//         subTitle: "Single dashboard for your entire service fleet.",
//       },
//       {
//         title: "Get alerts on faults, idle run, abnormal pressure",
//         subTitle: "Proactive notifications before issues become critical.",
//       },
//       {
//         title: "Trigger service tickets automatically",
//         subTitle: "Streamlined workflow from detection to resolution.",
//       },
//       {
//         title: "AMC/Contract expiry reminders",
//         subTitle: "Never miss a renewal opportunity.",
//       },
//     ],
//   },
//   endUser: {
//     label: "End Users",
//     // img: oemSolution,
//     title: "Optimize Energy. Eliminate Downtime",
//     subTitle:
//       "Take control of your compressed air systems with intelligent monitoring and optimization.",
//     contents: [
//       {
//         title: "Track energy, load-unload %, runtime",
//         subTitle: "Complete visibility into system performance.",
//       },
//       {
//         title: "Preventive alerts for pressure drop & idle hours",
//         subTitle: "Avoid costly breakdowns and energy waste.",
//       },
//       {
//         title: "Reduce maintenance cost and carbon footprint",
//         subTitle: "Sustainable operations with measurable impact.",
//       },
//       {
//         title: "Connects with multi brand, multi age compressors",
//         subTitle: "Universal compatibility across your fleet.",
//       },
//     ],
//   },
// };

// const PLATFORM_FEATURES = [
//   {
//     title: "Energy Management",
//     img: energyDashboard,
//     contents: [
//       "Real-time kWh, load/unload %",
//       "kW/CFM, kW/FAD calculations",
//       "Leak detection via pressure drop analytics",
//       "Energy benchmarking across compressors",
//     ],
//   },
//   {
//     title: "Service Management",
//     img: energyDashboard,
//     contents: [
//       "Ticketing workflows.",
//       "Failure mode tagging.",
//       "Service cycle tracking.",
//       "AMC/Breakdown KPIs.",
//       "Engineer App View.",
//     ],
//   },
//   {
//     title: "Analytics",
//     img: energyDashboard,
//     contents: [
//       "Custom dashboards.",
//       "Alerts for idle run, high pressure, undervoltage.",
//       "Machine benchmarking.",
//       "Uptime reports and carbon savings.",
//     ],
//   },
//   {
//     title: "AI + Predictive",
//     img: energyDashboard,
//     contents: [
//       "ML-based prediction of failures.",
//       "Component wear detection.",
//       "Dynamic thresholding & anomaly detection.",
//     ],
//   },
// ];

// const WORKS_STEPS = [
//   {
//     title: "Step 1: Retrofit Gateway",
//     icon: Icons(100, 100, "#66e766").Gateway(),
//     info: "Install our IoT gateway with Modbus/4-20 mA connectivity to your existing compressor.",
//   },
//   {
//     title: "Step 2: Connect to Cloud",
//     icon: Icons(100, 100, "#66e766").Cloud(),
//     info: "Secure connection to Kompress.ai cloud platform for real-time data processing.",
//   },
//   {
//     title: "Step 3: Access Dashboard",
//     icon: Icons(100, 100, "#66e766").Dashboard(),
//     info: "Monitor from web dashboard or mobile app with real-time insights and alerts.",
//   },
//   {
//     title: "Step 4: Optimize",
//     icon: Icons(100, 100, "#66e766").Optimize(),
//     info: "Use AI-powered insights to optimize energy consumption and prevent downtime.",
//   },
// ];

function Solutions() {
  // const [cost, setCost] = useState("");
  // const [hoursOfOperation, sethoursOfOperation] = useState("");
  // const [motorHorsePower, setmotorHorsePower] = useState("");
  // const [energy, setEnergy] = useState("");
  // const [currency, setCurrency] = useState("$");
  // const [solutionBannerInfo, setSolutionBannerInfo] = useState({
  //   isActive: "oem",
  // });
  const location = useLocation();
  const solutionPageRefs = {
    solution: useRef(),
    features: useRef(),
    steps: useRef(),
    energyCost: useRef(),
    energyCalculation: useRef(),
    architechture: useRef(),
    solutionbanner: useRef(),
    carbon: useRef(),
    prediction: useRef(),
  };

  useEffect(() => {
    let ref = solutionPageRefs[location.state?.scrollTo];
    if (ref && ref.current) {
      const y =
        ref.current.getBoundingClientRect().top + window.pageYOffset - 150;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    //eslint-disable-next-line
  }, [location]);

  // const calculateEnergy = () => {
  //   if (cost !== "" && hoursOfOperation !== "" && motorHorsePower !== "") {
  //     setEnergy(cost * hoursOfOperation * motorHorsePower * 0.746);
  //   }
  // };

  // const handleTheBannerButtonClick = (data) => {
  //   setSolutionBannerInfo((pre) => ({
  //     ...pre,
  //     isActive: data,
  //   }));
  // };

  const handleTheCarbonReportDownload = () => {
    const pdfFile = require("./assets/Sample_Carbon_Footprint.pdf");
    window.open(pdfFile);
  };

  const handleTheEnergyReportDownload = () => {
    const pdfFile = require("./assets/Sample_Energy_Consumption_Report.pdf");
    window.open(pdfFile);
  };


  return (
    <React.Fragment>
      <Header />
      {/* 
      <div
        className="container-fluid solutions-bg"
        style={{ paddingTop: "50px" }}
        ref={solutionPageRefs.solution}
      >
        <div className="">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-md-10 col-sm-12 text-center">
              <img
                alt=""
                src={require("./images/kompress_logo_black.png")}
                width="200px"
              />
              <p className="para green-para">
                Real-time analytics for efficient performance
              </p>
              <p className="para solution-banner-para">
                Compressors contribute almost 10% of the total energy cost of an
                industrial plant. With Kompress.ai solution, industries can
                monitor the health of their compressors in real-time, enabling
                efficient run times and in turn, significant energy savings.
                Powered by an advanced algorithm, Kompress.ai enables monitoring
                of critical parameters and analytics to derive specific
                performance and utilization insights. It can be integrated with
                any existing ERP/data management IOT layer already deployed at
                the plant. We also provide retrofitting to existing
                installations. We currently work directly with many leading air
                compressor manufacturers and also global industry users of
                compressors such as Oil & Gas, Automotive, Pharmaceuticals,
                Bottling Plants, Drilling and Construction, and Cement, among
                other industries.
              </p>
            </div>
          </div>
          <div>
            <div className="d-flex flex-column solution-banner-container">
              <span className="solution-banner-title">Solutions</span>
              <span className="solution-banner-sub-title">Tailored solutions for every stakeholder</span>
            </div>
            <div className="d-flex solution-banner-button-classification-container">
              {Object.keys(BANNER_CONTENTS).map((data) => {
                let isActive = solutionBannerInfo.isActive === data;
                return (
                <div
                className={`solution-banner-button
                ${(data === "oem") ? "solution-banner-button-left" : ""}
                ${(data === "endUser") ? "solution-banner-button-right" : ""}
                ${isActive ? "solution-banner-button-active" : ""}`
              }
              onClick={() => handleTheBannerButtonClick(data)}
                >{BANNER_CONTENTS[data].label}</div>
              )}
              )}
            </div>
            <div className="sloution-banner-contents-parent">
              <div className="solution-banner-contents-container">
                <div className="d-flex flex-column solution-banner-contents-header-container">
                  <span className="solution-banner-contents-title">
                    {BANNER_CONTENTS[solutionBannerInfo.isActive].title}
                  </span>
                  <span className="solution-banner-contents-sub-title">
                    {BANNER_CONTENTS[solutionBannerInfo.isActive].subTitle}
                  </span>
                </div>
                <div className="d-flex flex-column solution-banner-content-headings-container">
                  {BANNER_CONTENTS[solutionBannerInfo.isActive].contents.map((data) => {
                    return (
                      <div className="d-flex flex-column solution-banner-content-headings">
                        <span className="solution-banner-content-heading">
                          {Icons(16,16, "#66e766").Tick()} {data.title}
                        </span>
                        <span className="solution-banner-content-sub-heading">{data.subTitle}</span>
                      </div> 
                    )
                  })}
                </div>
              </div>
              <div className="solution-banner-contents-img-container">
                <img alt="" className="solution-banner-contents-img" src={BANNER_CONTENTS[solutionBannerInfo.isActive].img} />
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div
        ref={solutionPageRefs.solutionbanner}
        className="solution-banner-parent-container"
      >
        <div className="solution-banner-container">
          <span className="solution-banner-title">
            Tangible Impact Across Every Industry
          </span>
          <span className="solution-banner-sub-title">
            Across hundreds of connected compressors, Kompress.ai delivers
            measurable gains that go beyond data and dashboards. Energy is
            saved, emissions are reduced, and downtime becomes predictable.
          </span>
          <div className="solution-banner-child-container">
            {[
              {
                title: "12-20% ",
                info: "Average Energy Savings",
                key: 1,
              },
              {
                title: "30-60",
                info: "CO₂ Tons Avoided Annually",
                key: 2,
              },
              {
                title: "50%",
                info: "Fewer Unplanned Events",
                key: 3,
              },
              {
                title: "6-12",
                info: "Months to ROI",
                key: 4,
              },
            ].map((data) => {
              return (
                <div
                  className={`solution-banner-child-content-container
            ${data.key === 1 ? "banner-child-1" : ""}
            ${data.key === 2 ? "banner-child-2" : ""}
            ${data.key === 3 ? "banner-child-3" : ""}
            ${data.key === 4 ? "banner-child-4" : ""}
            `}
                >
                  <span
                    className={`solution-child-title
                ${data.key === 1 ? "banner-child-title-1" : ""}
                ${data.key === 2 ? "banner-child-title-2" : ""}
                ${data.key === 3 ? "banner-child-title-3" : ""}
                ${data.key === 4 ? "banner-child-title-4" : ""}
              `}
                  >
                    {data.title}
                  </span>
                  <span className="solution-child-info">{data.info}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div
        ref={solutionPageRefs.carbon}
        className="solution-cut-energy-container"
      >
        <div className="solution-cut-energy-title-container">
          <span className="solution-cut-energy-title">
            Cut Energy Costs. Measure Your Carbon Impact.
          </span>
          <span className="solution-cut-energy-left-title-container">
            Up to 30% of plant energy is lost in compressed air systems.
            Kompress.ai helps you reclaim it.
          </span>
        </div>
        <div className="solution-cut-energy-child-container">
          <div className="solution-cut-energy-left-container">
            {/* <span className="solution-cut-energy-left-sub-title-container">
              With continuous monitoring and AI-based optimization, Kompress.ai
              identifies energy leaks, idle runs, and inefficiencies across your
              compressor network. Every unit of air delivered is tracked against
              power consumed, giving you actionable insights into efficiency and
              emissions.
            </span> */}
            <span className="solution-cut-energy-left-sub-title-container">
              Kompress.ai monitors your compressors in real time, detects energy waste, and shows how every unit of air uses power.
            </span>
            <ul className="solution-cut-energy-ul-container">
              <li className="solution-cut-energy-li-container">
                Real-time kW/CFM & SPC (Specific Power Consumption)
              </li>
              <li className="solution-cut-energy-li-container">
                Leak detection and idle load analysis
              </li>
              <li className="solution-cut-energy-li-container">
                Automated CO₂ emission reports (ISO 50001 ready)
              </li>
              <li className="solution-cut-energy-li-container">
                Verified energy and carbon savings benchmarks
              </li>
            </ul>
            <div className="solution-cut-energy-btn-container">
              <button
              onClick={() => handleTheEnergyReportDownload()}
              className="solution-cut-energy-audit-btn-container">
                {Icons(25, 25, "#ffff").Download()}                
                Sample Energy Report
              </button>
              <button
                onClick={() => handleTheCarbonReportDownload()}
                className="solution-cut-energy-co2-btn-container"
              >
                {Icons(25, 25, "#ffff").Download()}
                Sample CO₂ Report
              </button>
            </div>
          </div>
          <div className="solution-cut-energy-right-container">
            <img src={require("./images/energy_carbon.png")} alt="" />
          </div>
        </div>
      </div>
      {/* 
      <div ref={solutionPageRefs.features} className="container-fluid solution-features-bg">
        <div className="">
          <div className="text-center solution-features-header">
            <h2>Platform Features</h2>
            <p>Comprehensive monitoring and management capabilities</p>
          </div>
          <div className="solution-features-grid">
            {PLATFORM_FEATURES.map((feature, index) => (
              <div className="solution-feature-card" key={index}>
                <div className="solution-feature-icon">{Icons(50,50,"#66e766").Dashboard()}</div>
                <h3 className="solution-feature-title">{feature.title}</h3>
                <ul className="solution-feature-list">
                  {feature.contents.map((item, i) => (
                    <li key={i}>
                      <span className="tick-icon">{Icons(16,16,"#66e766").Tick()}</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <div>
                <img alt="" className="solution-feature-card-img" src={data.img}/>
              </div>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-12 text-center brand-heading">
              Why Kompress.ai
            </div>

            <div className="col-12">
              <div className="row why-utv-panel-column solutions">
                <div className="col col-md-3 col-sm-12 text-center why-utv-panel">
                  <img alt="" src={require("./images/why_utv_1.png")} />
                  <p className="para pink-para">Reduced Energy costs</p>
                  <h2 className="sub-heading">
                    Saves 15% on energy cost and 10% on maintenance costs of
                    your compressors
                  </h2>
                  <span id="energy">&nbsp;</span>
                </div>
                <div className="col col-md-3 col-sm-12 text-center why-utv-panel">
                  <img alt="" src={require("./images/why_utv_2.png")} />
                  <p className="para pink-para">Zero unplanned downtimes</p>
                  <h2 className="sub-heading">
                    Predicts and manage operational disruptions from unplanned
                    servicing and fault detection
                  </h2>
                </div>
                <div className="col col-md-3 col-sm-12 text-center why-utv-panel">
                  <img alt="" src={require("./images/why_utv_3.png")} />
                  <p className="para pink-para">Stay connected remotely</p>
                  <h2 className="sub-heading">
                    Monitor compressor health through an app remotely and stay
                    connected 24/7
                  </h2>
                </div>
                <div className="col col-md-3 col-sm-12 text-center why-utv-panel">
                  <img alt="" src={require("./images/why_utv_3.png")} />
                  <p className="para pink-para">
                    Optimize with actionable insights
                  </p>
                  <h2 className="sub-heading">
                    Keep compressor health in check with regular opetational
                    insights on the equipment
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div
        ref={solutionPageRefs.prediction}
        className="solution-breakdown-energy-container"
      >
        <div className="solution-breakdown-energy-title-container">
          <span className="solution-breakdown-energy-title">
            From Breakdowns to Predictability
          </span>
          <span className="solution-breakdown-energy-sub-title-container">
            Reduce downtime and maintenance costs with AI-powered predictive
            alerts.
          </span>
        </div>
        <div className="solution-breakdown-energy-child-container">
          <div className="solution-breakdown-energy-right-container">
            <img src={require("./images/predictive_maintenance.png")} alt="" />
          </div>
          <div className="solution-breakdown-energy-left-container">
            {/* <span className="solution-breakdown-energy-left-sub-title-container">
              Kompress.ai analyzes pressure, temperature, and runtime trends to
              predict issues before they cause breakdowns. The system
              auto-generates alerts, recommends actions, and even integrates
              with service workflows for proactive maintenance.
            </span> */}
            <span className="solution-breakdown-energy-left-sub-title-container">
              Kompress.ai tracks pressure, temperature, and run hours to spot issues early. It sends alerts, suggests fixes, and supports proactive maintenance.
            </span>
            <ul className="solution-breakdown-energy-ul-container">
              <li className="solution-breakdown-energy-li-container">
                Machine learning-driven predictive models
              </li>
              <li className="solution-breakdown-energy-li-container">
                Smart alerts on pressure drops, high idle hours, bearing wear
              </li>
              <li className="solution-breakdown-energy-li-container">
                Maintenance tickets & technician dispatch integration
              </li>
              <li className="solution-breakdown-energy-li-container">
                Spare forecasting to optimize inventory and service cost
              </li>
            </ul>
            {/* <div className="solution-breakdown-energy-btn-container">
              <button className="solution-breakdown-energy-audit-btn-container">Enable Predictive Alerts</button>
              <button className="solution-breakdown-energy-co2-btn-container">See a Live Dashboard</button>
            </div> */}
          </div>
        </div>
      </div>

      <div className="solution-plant-container">
        <span className="solution-plant-title">
          Your Plant Could Be the Next Success Story
        </span>
        <span className="solution-plant-info">
          Every compressor tells a story. With Kompress.ai, those stories end
          with energy saved, emissions lowered, and uptime improved. Start your
          own journey toward intelligent air efficiency today.
        </span>
        <div className="solution-plant-btn-groups">
          {/* <button className="solution-plant-req-btn">
            See How Kompress.ai Works
          </button> */}
          {/* <button className="solution-plant-pilot-btn">
            Talk to Our Team
          </button> */}
        </div>
      </div>

      {/* <div className="solution-access-dashboard-container">
        <div className="solution-access-dashboard-child-container">
          <span className="solution-access-dashboard-child-title">Access Your Dashboard</span>
          <span className="solution-access-dashboard-child-sub-title">Already a customer? Login to monitor your compressed air systems in real-time.</span>
          <div className="solution-access-dashboard-child-btn-group">
            <button className="solution-access-dashboard-child-dashboard-btn">Login to Dashboard</button>
            <button className="solution-access-dashboard-child-help-btn">Need Help?</button>
          </div>
        </div>
      </div> */}

      <div className="solution-page-transform-container">
        <div className="solution-page-transform-child-container">
          <span className="solution-page-transform-child-title">
            Ready to Transform Your Compressed Air System?
          </span>
          <span className="solution-page-transform-child-sub-title">
            Join leading manufacturers who are already saving energy, reducing
            emissions, and improving reliability with Kompress.ai.
          </span>
          <div className="solution-page-transform-child-btn-groups">
            {/* <button
          onClick={() => {
            window.location.href="mailto:sales@utvyakta.com"
          }}
          className="solution-page-transform-child-btn-trial">
            Start Trial
          </button> */}
            <button
              onClick={() => {
                var a = document.getElementsByClassName("active-link");
                a[0].click();
              }}
              className="solution-page-transform-child-btn-schedule"
            >
              Schedule a Consultation
            </button>
          </div>
        </div>
      </div>

      {/* 
      <div ref={solutionPageRefs.steps} className="container-fluid container-how-works">
        <div className="d-flex flex-column solution-how-works-container">
            <div className="d-flex flex-column solution-how-works-container-header">
              <span className="solution-how-works-container-header-title">How It Works</span>
              <span className="solution-how-works-container-header-sub-title">Simple 4-step process to get started</span>
            </div>
            <div className="d-flex solution-how-works-card-container">
              {WORKS_STEPS.map((data) => <div className="solution-how-works-card">
                <div className="solution-how-works-card-icon-container">
                  <span className="solution-how-works-card-icon">
                    {data.icon}
                  </span>
                </div>
                <div className="d-flex flex-column solution-how-works-card-contents-container">
                  <span className="solution-how-works-card-contents-title">{data.title}</span>
                  <span className="solution-how-works-card-contents-sub-title">
                  {data.info}  
                  </span>
                </div>
              </div>)}
            </div>
        </div>
      </div>

      <div ref={solutionPageRefs.energyCost} className="container-fluid grey-bg">
        <div className="">
          <div className="col-12 text-center brand-heading">
            Energy &amp; cost saving with Kompress.ai
          </div>
          <div className="col-12 text-center">
            <img
              alt=""
              src={require("./images/energy_1.png")}
              style={{ width: "100%" }}
              className="desktop-only"
            />
            <img
              alt=""
              src={require("./images/energy_1_mobile.png")}
              style={{ width: "100%" }}
              className="mobile-only"
            />
            <img
              alt=""
              src={require("./images/energy_2.png")}
              style={{ width: "100%" }}
              className="desktop-only"
            />
            <img
              alt=""
              src={require("./images/energy_2_mobile.png")}
              style={{ width: "100%" }}
              className="mobile-only"
            />
          </div>

          <div ref={solutionPageRefs.energyCalculation} className="colmd--12" style={{ paddingTop: "0px" }}>
            <div className="col-12 text-center brand-heading">
              Calculate your current energy spend
            </div>
            <div className="row energy-calculator">
              <div className="col-md-12 text-center energy-calculator-container">
                <div class="solution-styled-select">
                  <select
                    className="currency-selector"
                    onChange={(e) => setCurrency(e.target.value)}
                  >
                    <option
                      data-symbol="$"
                      value="$"
                      data-placeholder="0.00"
                      selected
                    >
                      USD
                    </option>
                    <option data-symbol="€" value="€" data-placeholder="0.00">
                      EUR
                    </option>
                    <option data-symbol="£" value="£" data-placeholder="0.00">
                      GBP
                    </option>
                    <option data-symbol="¥" value="¥" data-placeholder="0">
                      JPY
                    </option>
                    <option data-symbol="$" value="$" data-placeholder="0.00">
                      CAD
                    </option>
                    <option data-symbol="$" value="$" data-placeholder="0.00">
                      AUD
                    </option>
                    <option data-symbol="₹" value="₹" data-placeholder="0.00">
                      INR
                    </option>
                  </select>
                  <span class="fa fa-sort-desc"></span>
                </div>
                <div style={{ float: "left" }} className="solution-energy-calculator-container">
                  <input
                    type="text"
                    className="solution-subscribe-textbox"
                    placeholder="Cost per KWh"
                    required
                    name={cost}
                    onChange={(e) => setCost(e.target.value)}
                  />
                  <input
                    className="solution-subscribe-textbox hours-of-operation-textbox"
                    placeholder="Hours of operation per year"
                    required
                    type="text"
                    name={hoursOfOperation}
                    onChange={(e) => sethoursOfOperation(e.target.value)}
                  />
                  <input
                    className="solution-subscribe-textbox"
                    placeholder="Motor horsepower"
                    required
                    type="text"
                    name={motorHorsePower}
                    onChange={(e) => setmotorHorsePower(e.target.value)}
                  />
                  <input
                    className="solution-subscribe-textbox clear-btn pink-btn schedulebtn"
                    required
                    style={{ color: "#ffffff" }}
                    type="button"
                    value="Calculate"
                    onClick={calculateEnergy}
                  />
                </div>
              </div>
              <span id="solutionArchitecture">&nbsp;</span>
            </div>

            <div className="row">
              <div className="col-md-12 text-center">
                <br />
                {energy !== "" && (
                  <React.Fragment>
                    <h2 className="sub-heading">
                      Current energy spend:{" "}
                      <span className="thick-font">
                        {" "}
                        {currency}
                        {energy}
                      </span>{" "}
                      per year{" "}
                    </h2>
                    <h3 className="sub-heading">
                      Talk to us to know potential energy savings!
                    </h3>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div ref={solutionPageRefs.architechture} className="container-fluid" id="architecture">
        <div className="">
          <div className="row">
            <div className="col-12 text-center brand-heading solution-sub-heading">
              Architected for efficiency. Designed for scale.
            </div>
            <div className="col-12">
              <h3 className="sub-heading">
                Kompress.ai has been designed to be modular and compatible with
                any existing compressor of any type. The solution can be
                installed with minimal disruption to your existing operations.
                Robust sensors and a dedicated data network ensure you receive
                reliable updates in real-time.
              </h3>
            </div>

            <div className="col-md-12">
              <img alt="" src={require("./images/kompress.png")} width="100%" />
            </div>
          </div>
        </div>
      </div> */}

      {/* <div
        className="container-fluid solutions-bg"
        style={{ paddingTop: "100px", paddingBottom: "50px" }}
      >
        <div className="">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-md-10 col-sm-12 text-center">
              <p className="para green-para">
                Monitor all the critical parameters
              </p>
            </div>

            <div className="col-12">
              <h3 className="sub-heading" style={{ color: "#ffffff" }}>
                With Kompress.ai installed, you will gain complete visibility on
                every aspect of a running compressor. A real-time view of all
                critical parameters will give you the advantage of planned and
                proactive maintenance, reducing breakdown calls for the OEMs and
                service providers.
              </h3>
            </div>

            <div className="col-12">
              <div
                className="row why-utv-panel-column solutions solution-four"
                style={{ justifyContent: "center" }}
              >
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/compressor.png")} />
                  <p className="para pink-para">Compressor Status (On/Off)</p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/pressure.png")} />
                  <p className="para pink-para">Pressure Monitor</p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/tempreature.png")} />
                  <p className="para pink-para">Temperature Checking</p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/energy.png")} />
                  <p className="para pink-para">
                    Energy
                    <br /> Savings
                  </p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/runhour.png")} />
                  <p className="para pink-para">Run Hours Monitoring</p>
                </div>
              </div>

              <div
                className="row why-utv-panel-column solutions solution-four"
                style={{ justifyContent: "center" }}
              >
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/airfilter.png")} />
                  <p className="para pink-para">Air Filter (Used Hours)</p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/oilfilter.png")} />
                  <p className="para pink-para">
                    Oil Filter
                    <br /> (Used Hours)
                  </p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/service-overdue.png")} />
                  <p className="para pink-para">
                    Service&nbsp;Overdue
                    <br /> Alerts
                  </p>
                </div>
                <div className="col col-md-2 col-sm-3 text-center why-utv-panel">
                  <img alt="" src={require("./images/voltage_control.png")} />
                  <p className="para pink-para">
                    Voltage
                    <br /> Control
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-12 text-center brand-heading solution-sub-heading">
              Power better decisions with remote tracking
            </div>
            <div className="col-12">
              <h3 className="sub-heading" style={{ width: "70%" }}>
                The Kompress.ai dashboard gives you an always-on, intelligent
                remote tracking analysis, allowing for greater performance
                visibility. Reduce downtime, save costs and increase RoI through
                a data-led decision support system.
              </h3>
              <p
                className="para green-para"
                style={{ textAlign: "center", fontSize: "15pt" }}
              >
                Real-time analytics for efficient performance
              </p>
            </div>

            <div className="col-md-8">
              <img alt="" src={require("./images/system.png")} width="100%" />
            </div>
          </div>
        </div>
      </div> */}

      <Footer pageRefs={solutionPageRefs} />
    </React.Fragment>
  );
}
export default Solutions;
